



































































import {Component, Vue} from '@/shared/component';
import {Stored} from "vue-stored-prop-decorator";
import {User} from '@/models';
import {ResultType} from "@/shared/xhttp";

import storeUser from '@/stores/modules/user';
import CrudAchatList from "@/components/Crud/Achat/List.vue";
import CrudAchatFilter from "@/components/Crud/Achat/Filter.vue";
import CrudLivraisonFilterTotauxLivraisons from "@/components/Crud/Livraison/FilterTotauxLivraisons.vue";
import CrudLivraisonListTotauxLivraisons from "@/components/Crud/Livraison/ListTotauxLivraisons.vue";
import CrudEssenceAchatListTotauxEssenceAchats from "@/components/Crud/EssenceAchat/ListTotauxEssenceAchats.vue";
import CrudEssenceAchatFilterTotauxEssenceAchats from "@/components/Crud/EssenceAchat/FilterTotauxEssenceAchats.vue";
import CrudEssenceAchatFilterRechercheEssenceAchats from "@/components/Crud/EssenceAchat/FilterRechercheEssenceAchats.vue";
import CrudEssenceAchatListRechercheEssenceAchats from "@/components/Crud/EssenceAchat/ListRechercheEssenceAchats.vue";

@Component({
	components: {
		CrudAchatFilter,
		CrudLivraisonFilterTotauxLivraisons,
		CrudEssenceAchatFilterTotauxEssenceAchats,
		CrudEssenceAchatFilterRechercheEssenceAchats,
		CrudAchatList,
		CrudLivraisonListTotauxLivraisons,
		CrudEssenceAchatListTotauxEssenceAchats,
		CrudEssenceAchatListRechercheEssenceAchats,
	}
})
export default class TableauDeBordAchat extends Vue {

	//@Stored(() => storeCubageChantierRestant) cubageChantierRestants!: ResultType<CubageChantierRestant>;
	@Stored(() => storeUser) me!: User;

	public created(): void {
	//	storeCubageChantierRestant.state.filters.boisType = true;
	//	storeCubageChantierRestant.state.filters.boisQuality = true;
	//	storeCubageChantierRestant.state.filters.boisSize = true;
	//	storeCubageChantierRestant.state.filters.nullValue = false;
	//	storeCubageChantierRestant.state.filters.groupChantier = false;
	//	storeCubageChantierRestant.state.filters.chantier = null;

		//console.log("created");
	}

	public mounted(): void {
		//this.addEventDom(window, 'resize', () => this.$forceUpdate());
		//console.log("mounted");
	}

}
